import { useWatch } from 'react-hook-form';

import { useSankeyFormContext } from 'contexts/sankeyFormContext';

import { useAmountFormatter } from '../../diagram/formatting';
import { ep } from '../../diagram/numbers';
import { SankeyNode } from '../../diagram/types';
import { useSankeyNodeInteraction } from '../SankeyInteractionProvider/utils';
import NodeEditPopover from './popovers/NodeEditPopover';

type Props = {
  node: SankeyNode;
};

const SankeyNodeRectangle: React.FC<Props> = ({ node }) => {
  const { form } = useSankeyFormContext();
  const [showLabels] = useWatch({
    control: form.control,
    name: ['show_labels'],
  });

  const {
    handleMouseOut,
    handleMouseOver,
    handleMouseDown,
    handleDoubleClick,
  } = useSankeyNodeInteraction(node);

  const formatAmount = useAmountFormatter();

  return (
    <NodeEditPopover node={node}>
      <rect
        className="node"
        cursor="pointer"
        height={ep(node.dy)}
        width={ep(node.dx)}
        fill={node.color}
        transform={`translate(${ep(node.x)}, ${ep(node.y)})`}
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
        onMouseDown={handleMouseDown}
        onDoubleClick={handleDoubleClick}
      >
        {!showLabels && (
          <title>
            {node.name}: {formatAmount(node.amount)}
          </title>
        )}
      </rect>
    </NodeEditPopover>
  );
};

export default SankeyNodeRectangle;
